function calculateCoppercoat() {
  const factor = parseFloat(document.getElementById("boatType").value);
  const waterline = parseFloat(document.getElementById("waterline").value) || 0;
  const beam = parseFloat(document.getElementById("beam").value) || 0;
  const draft = parseFloat(document.getElementById("draft").value) || 0;

  let area = waterline * (beam + draft);
  area = area * factor;

  // litres required (rounded UP)
  let litres = Math.ceil(area / 4);

  document.getElementById("areaResult").innerText =
    "Area to cover = " + area.toFixed(2) + " m²";

  document.getElementById("litreResult").innerText =
    "Coppercoat required = " + litres + " litres";
}